import request from '@/router/axios'

export function getInviteNum(obj) {
    return request({
        url: '/api/screen/getinvitedata',
        method: 'post',
        data: obj
    })
}

export function getInviteDetail(obj) {
    return request({
        url: '/api/screen/getinvitelist',
        method: 'post',
        data: obj
    })
}


export function getuseractivedata(obj) {
    return request({
        url: '/api/screen/getuseractivedata',
        method: 'post',
        data: obj
    })
}

export function getanalyseuserdata(obj) {
    return request({
        url: '/api/screen/getanalyseuserdata',
        method: 'post',
        data: obj
    })
}
export function getallanalysedata(obj) {
    return request({
        url: '/api/screenkaihu/getallresevationdata',
        method: 'post',
        data: obj
    })
}
export function getsignlist(obj) {
    return request({
        url: '/api/screen/getsignlist',
        method: 'post',
        data: obj
    })
}

export function getuseractivelist(obj) {
    return request({
        url: '/api/screen/getuseractivelist',
        method: 'post',
        data: obj
    })
}

export function getActiveCount(obj) {
    return request({
        url: '/api/screen/getanalysedata_date',
        method: 'post',
        data: obj
    })
}

//获取日活列表
export function getDayActiveList(obj) {
    return request({
        url: '/api/screen/getdayuvlist',
        method: 'post',
        data: obj
    })
}

//获取月活列表
export function getMonActiveList(obj) {
    return request({
        url: '/api/screen/getmonthuvlist',
        method: 'post',
        data: obj
    })
}